import { VueConstructor } from 'vue';
import NoData from './index.vue';

export default {
  install: (vue: VueConstructor) => {
    vue.component('no-data', NoData);
  }
};
